import { useEffect, useState } from "react";
import api, { apiError } from "../../lib/api";
import { inr, pct, gainClass } from "../../lib/format";
import AppLayout, { PageLoader, EmptyState, thCls, tdCls, rowCls } from "../../components/AppLayout";

export default function HoldingsPage() {
  const [data, setData] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    api.get("/investor/holdings").then((r) => setData(r.data)).catch((e) => setError(apiError(e)));
  }, []);

  if (error) return <AppLayout title="Holdings"><p className="text-red-400 text-sm">{error}</p></AppLayout>;
  if (!data) return <AppLayout title="Holdings"><PageLoader /></AppLayout>;

  return (
    <AppLayout title="Holdings" subtitle={`${data.holdings.length} positions · Total current value ${inr(data.metrics.current_value)}`}>
      <div className="glass-card overflow-hidden fade-up">
        {data.holdings.length === 0 ? <EmptyState message="No holdings found." /> : (
          <div className="overflow-x-auto">
            <table className="w-full text-sm" data-testid="holdings-full-table">
              <thead>
                <tr className="border-b border-white/[0.06]">
                  <th className={thCls}>Asset / Fund</th>
                  <th className={thCls}>Class</th>
                  <th className={`${thCls} text-right`}>Units</th>
                  <th className={`${thCls} text-right`}>Invested</th>
                  <th className={`${thCls} text-right`}>Current Value</th>
                  <th className={`${thCls} text-right`}>Gain / Loss</th>
                  <th className={`${thCls} text-right`}>Return %</th>
                  <th className={`${thCls} text-right`}>Allocation %</th>
                </tr>
              </thead>
              <tbody>
                {data.holdings.map((h) => (
                  <tr key={h.id} className={rowCls} data-testid={`holding-row-${h.id}`}>
                    <td className={`${tdCls} font-medium text-white`}>{h.asset_name}</td>
                    <td className={`${tdCls} text-zinc-500 text-xs`}>{h.category}</td>
                    <td className={`${tdCls} text-right tnum text-zinc-500`}>{h.units ?? "—"}</td>
                    <td className={`${tdCls} text-right tnum text-zinc-300`}>{inr(h.invested_amount)}</td>
                    <td className={`${tdCls} text-right tnum text-zinc-100`}>{inr(h.current_value)}</td>
                    <td className={`${tdCls} text-right tnum ${gainClass(h.gain_loss)}`}>{inr(h.gain_loss)}</td>
                    <td className={`${tdCls} text-right tnum font-semibold ${gainClass(h.return_pct)}`}>{pct(h.return_pct)}</td>
                    <td className={`${tdCls} text-right tnum text-zinc-400`}>{pct(h.allocation_pct, 1)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </AppLayout>
  );
}
